import styled from "@emotion/styled"
import { SetStateAction } from "jotai"
import { Dispatch, useEffect, useState } from "react"
import DepositBlockTitle from "../components/DepositBlockTitle"
import ValueInput from "./ValueInput"

const Container = styled.div`
    border-radius: 10rem;
    background-color: #ffffff;
    padding: 12rem;
    padding-bottom: 12rem;
    margin: 12rem;
`

export default function VoucherCode({
    setCode,
    code,
    errorMsg,
}: {
    code: string
    errorMsg: string
    setCode: Dispatch<SetStateAction<string>>
}) {
    const [val, setVal] = useState<string>("")

    useEffect(() => {
        setVal(val.replace(/\s+/g, ""))
    }, [val])

    useEffect(() => {
        setCode(val)
    }, [setCode, val])

    return (
        <Container>
            <DepositBlockTitle>Lazada Voucher Code</DepositBlockTitle>
            <ValueInput
                placeholder={"Enter Voucher Code"}
                value={code}
                onChange={(v) => setVal(v)}
                errorMsg={errorMsg}
                maxLength={50}
            />
        </Container>
    )
}
